import { useNavigate } from 'react-router-dom';
import { setSampleJob } from 'hooks/useRunABJob';
import JobsList from './JobsList';
import JobsEmptyList from './JobsEmptyList';

const Jobs = ({
  jobs, page, total, rowsPerPage, setPage, setRowsPerPage, columns, handleSearch, searchQuery, onFilterChange, filters,
}) => {
  const navigate = useNavigate();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleSampleJobGeneration = () => {
    setSampleJob();
    navigate('/jobs/GX3WjL3ZghA0564B');
  };

  // If there are jobs or if the user has searched for something, show the jobs list
  if (jobs.length || searchQuery) {
    return (
      <JobsList
        columns={columns}
        jobs={jobs}
        page={page}
        total={total}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleSearch={handleSearch}
        searchQuery={searchQuery}
        onFilterChange={onFilterChange}
        filters={filters}
      />
    );
  }

  // If there are no jobs and the user hasn't searched for anything, show the empty list
  return <JobsEmptyList onSampleJobGenerate={handleSampleJobGeneration} />;
};

export default Jobs;
